export default function Playstation() {
  return (
    <div
      className="ion-icon-playstation"
      dangerouslySetInnerHTML={{
        __html: `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="512px" height="512px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
<style type="text/css">
<![CDATA[
	.st0{fill:#010101;}
]]>
</style>
<g>
	<path class="st0" d="M399.8,203c-0.8-17.1-3.3-34.5-10.8-50.1c-4.1-8.6-9.7-16.5-16.5-23.2c-6.3-6.4-13.6-11.7-21.3-16.3
		c-17.1-10.2-37.5-17-84.4-31S192,64,192,64v358.3l79.9,25.7c0,0,0.1-198.8,0.1-299.5v-3.8c0-9.3,7.5-16.8,16.1-16.8h0.5
		c8.5,0,15.5,7.5,15.5,16.8v2.2v131.1c11,5.3,29.2,9.3,41.8,9.1c8.3,0.2,16.7-1.7,24-5.7c7.6-4.1,13.9-10.4,18.4-17.8
		c5.1-8.3,8.2-17.8,9.9-27.3C400.1,225.5,400.2,214.2,399.8,203z"/>
	<path class="st0" d="M86.7,357.8c27.4-9.8,89.3-29.5,89.3-29.5v-47.2c0,0-76.5,24.8-111.3,37.1c-8.6,3.1-17.3,5.9-25.7,9.5
		c-9.8,4.1-19.4,8.7-28.1,14.8c-3.8,2.6-7.2,5.9-9.2,10.1c-2,4.2-2.2,9.2-0.5,13.6c2,5.1,5.8,9.3,10.1,12.6
		c7.8,5.9,17.1,9.5,26.4,12.2c28.4,9.4,58.4,14,88.4,13.3c14.5-0.2,36-1.9,50-4.4v-42c0,0-11,2.5-41.3,12.5c-4.6,1.5-9.2,3.3-14,4.3
		c-7.1,1.6-14.4,2.1-21.6,2.2c-6.5-0.3-13.2-0.7-19.3-3.1c-2.2-1-4.6-2.2-5.5-4.6c-0.8-2,0.3-4,1.7-5.4
		C78.9,360.9,82.9,359.3,86.7,357.8z"/>
	<path class="st0" d="M512,345.9c-0.1-6-3.7-11.2-7.9-15c-7.1-6.3-15.9-10.3-24.7-13.5c-5.5-1.9-9.3-3.3-14.7-5
		c-25.2-8.2-51.9-11.2-78.3-11.3c-8,0.3-23.1,0.5-31,1.4c-21.9,2.5-67.3,15.4-67.3,15.4v48.8c0,0,67.5-21.6,96.5-31.8
		c9.7-3.3,20.1-4.6,30.3-4.6c6.5,0.2,13.2,0.7,19.4,3.1c2.2,0.9,4.5,2.2,5.5,4.5c0.9,2.6-0.9,5-2.9,6.5c-4.7,3.8-10.7,5.3-16.2,7.4
		C379.7,366.3,288,396.5,288,396.5v47c0,0,117.2-39.6,170.8-58.8c8.9-3.3,17.9-6.1,26.4-10.4c7.9-4,15.8-8.6,21.8-15.3
		C510.1,355.4,512,351,512,345.9z"/>
</g>
</svg>
`,
      }}
    />
  )
}
